import { RefurbishedPendingOrderInterface } from "../../../common/interfaces/apiV2/refurbished/RefurbishedPendingOrderInterface";
import { RefurbishedProductStateInterface } from "../../../common/interfaces/apiV2/shared/RefurbishedProductStateInterface";

export type RefurbishedProductButtonVariant =
    "primary" | "reserved" | "reserved-other";

export const isReservedByCurrentUser = (
    productId: number,
    pendingOrder: RefurbishedPendingOrderInterface | null,
): boolean =>
    pendingOrder?.order_lines.some(
        (line) => line.refurbished_product_id === productId,
    ) ?? false;

export const getRefurbishedProductButtonVariant = (
    state: RefurbishedProductStateInterface,
    pendingOrder: RefurbishedPendingOrderInterface | null,
    productId: number,
): RefurbishedProductButtonVariant => {
    if (isReservedByCurrentUser(productId, pendingOrder)) {
        return "reserved";
    }

    if (state.code.toLowerCase() === "reserved") {
        return "reserved-other";
    }

    return "primary";
};
